import React from "react"
import { Input } from "reactstrap"
class InputCheckbox extends React.Component {
  render() {
    return <Input {...this.props} type="checkbox" />
  }
}

//value: string
//defaultValue: string
//onChange: value = string

export default InputCheckbox
